import { getResultOr } from '@see-power-pft-common-js/utils/result/utils';

export const fetchWithAuth = async (
  {
    getJwtToken,
    signalAuthError,
  }: {
    getJwtToken: () => string | undefined;
    signalAuthError: () => Promise<void>;
  },
  url: string,
  init?: RequestInit,
): Promise<Response> => {
  const getFetchWithAuthResult = async () =>
    await getResultOr(
      (cause) => cause,
      async () => {
        const jwtToken = getJwtToken();

        const headers = new Headers(init?.headers);

        if (jwtToken) {
          headers.set('authorization', `Bearer ${jwtToken}`);
        }

        return await fetch(url, { ...init, headers });
      },
    );

  const initialResult = await getFetchWithAuthResult();
  if (!initialResult.success) {
    throw initialResult.error;
  }

  if (
    initialResult.value.status === 401 ||
    initialResult.value.status === 403
  ) {
    await signalAuthError();

    const retryResult = await getFetchWithAuthResult();
    if (!retryResult.success) {
      throw retryResult.error;
    }

    return retryResult.value;
  }

  return initialResult.value;
};
